// @react
import React, { ReactElement } from 'react'
// @types
import {
  GetConstantsQuery,
  GetConstantsQueryVariables,
  GetUserQuery,
  GetUserQueryVariables,
} from 'lib/graphql/graphqlTypes'
// @graphQL
import { useQuery } from '@apollo/client'
import { GET_USER } from 'graphql/queries/user.query'
import { GET_CONSTANTS } from 'graphql/queries/constants.query'
// @components
import WorkForm from 'modules/onBoarding/components/Work/Form'
// @module components
import QueryError from 'modules/common/components/Errors/QueryError'

/**
 *
 * @constructor
 */
const WorkContainer = (): ReactElement => {
  /****************************************
   *  GQL HOOKS
   ****************************************/

  const {
    loading: isUserLoading,
    error: isUserError,
    data: userData,
    refetch,
  } = useQuery<GetUserQuery, GetUserQueryVariables>(GET_USER, {
    fetchPolicy: 'cache-first',
  })

  const {
    loading: isConstantsLoading,
    error: isConstantsError,
    data: constantsData,
  } = useQuery<GetConstantsQuery, GetConstantsQueryVariables>(GET_CONSTANTS, {
    fetchPolicy: 'cache-first',
  })

  /****************************************
   *  RENDER
   ****************************************/

  const isLoading = isUserLoading || isConstantsLoading

  if (
    isUserError ||
    isConstantsError ||
    (!isLoading && (!userData || !constantsData))
  )
    return <QueryError />

  return (
    <WorkForm
      data={userData}
      refetch={refetch}
      constants={constantsData}
      isLoading={isLoading}
    />
  )
}

export default WorkContainer
